import { useRef, useCallback } from "react";
import service from "../../test-form/data.js";

export default function useFormData({ updateState, evaluateVisibility }) {
  const docRef = useRef(service.getEmployee());
  const templateRef = useRef(null);
  const settingsRef = useRef({});
  const formElementRef = useRef(null);

  const addOwner = useCallback((objectKey) => {
    docRef.current[objectKey].push({});
  }, []);

  const deleteOwner = useCallback((e) => {
    if (!e?.fields || !e.fields[0]?.object) return;
    const page = e.fields[0].object;
    if (!Array.isArray(docRef.current[page])) return;
    docRef.current[page].splice(e.index, 1);
    updateState({ _deleteTimestamp: Date.now() });
  }, [updateState]);

  const clearField = useCallback((dataForField, key, index) => {
    const fieldVisible = dataForField.visible
      ? evaluateVisibility(dataForField.visible.replaceAll("[x]", "[" + index + "]"))
      : evaluateVisibility(dataForField.visible);

    if (!fieldVisible) {
      try {
        // Safe path-based mutation instead of eval
        const parts = key.split(".");
        let obj = docRef.current;
        for (let i = 0; i < parts.length - 1; i++) {
          const part = parts[i];
          const arrayMatch = part.match(/^(\w+)\[(\d+)\]$/);
          if (arrayMatch) {
            obj = obj[arrayMatch[1]][parseInt(arrayMatch[2])];
          } else {
            obj = obj[part];
          }
          if (!obj) return;
        }
        const lastPart = parts[parts.length - 1];
        obj[lastPart] = null;
      } catch { }
    }
  }, [evaluateVisibility]);

  const clearUnvisibleData = useCallback(() => {
    const template = templateRef.current;
    if (!template) return;

    template.tabs.forEach((tab) => {
      const tabName = tab.Value.split("|")[0];
      if (tab.Type === "array") {
        for (let i = 0; i < docRef.current[tabName].length; i++) {
          Object.values(template[tabName]).forEach((value) => {
            clearField(value, tabName + "[" + i + "]." + value._uid, i);
          });
        }
      } else {
        Object.values(template[tabName]).forEach((value) => {
          clearField(value, tabName + "." + value._uid, "");
        });
      }
    });
  }, [clearField]);

  const countVisibleTabs = useCallback((tabs) => {
    if (!tabs) return 0;
    return tabs.filter((item) => evaluateVisibility(item.visible) === true).length;
  }, [evaluateVisibility]);

  return {
    docRef,
    templateRef,
    settingsRef,
    formElementRef,
    addOwner,
    deleteOwner,
    clearField,
    clearUnvisibleData,
    countVisibleTabs,
  };
}
